import { useRef } from "react";
import { format } from "date-fns";

export function formatDate(dateString: any) {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

// Phone number and country code
export const removeCountryCode = (
  countryCode: string,
  mobileNumber: string
): string => {
  const countryCodeWithPlus = `+${countryCode}`;
  if (mobileNumber.startsWith(countryCodeWithPlus)) {
    return mobileNumber.slice(countryCodeWithPlus.length);
  }
  return mobileNumber;
};

export function parseFullName(fullName: string | undefined) {
  if (!fullName) {
    return { firstName: "", middleName: "", lastName: "" };
  }

  const nameParts = fullName.trim().split(/\s+/);
  let firstName = "";
  let middleName = "";
  let lastName = "";

  if (nameParts.length === 1) {
    firstName = nameParts[0];
  } else if (nameParts.length === 2) {
    firstName = nameParts[0];
    lastName = nameParts[1];
  } else {
    firstName = nameParts[0];
    lastName = nameParts[nameParts.length - 1];
    middleName = nameParts.slice(1, -1).join(" ");
  }

  return { firstName, middleName, lastName };
}

export const Description = ({ text, style }: any) => {
  const descriptionRef = useRef<HTMLSpanElement>(null);

  const handleMouseLeave = () => {
    if (descriptionRef.current) {
      descriptionRef.current.scrollTop = 0;
    }
  };

  return (
    <span
      className={style}
      ref={descriptionRef}
      onMouseLeave={handleMouseLeave}
    >
      {text}
    </span>
  );
};

export const AWS_STRAPI_JSON_DATA_FOLDER_NAME = `${process.env.FOLDER_AWS}/strapi-api-jsondata`;
export const extractMonthAndDateAndTime = (
  dateString: string
): {
  formattedNewMonth: string;
  formattedNewDate: string;
  formatTime: string;
} => {
  const date = new Date(dateString);
  const formattedNewMonth = format(date, "MMM");
  const formattedNewDate = format(date, "dd");
  const formatTime = format(date, "hh:mm a");
  return {
    formattedNewMonth,
    formattedNewDate,
    formatTime,
  };
};

export const extractDateAndTime = (
  dateString: string
): { formateDate: string; formatTime: string } => {
  const date = new Date(dateString);
  const formattedDate = format(date, "MMMM dd, yyyy");
  const formattedTime = format(date, "hh:mm a");
  return { formateDate: formattedDate, formatTime: formattedTime };
};
